import User from 'src/models/Users/User'
import Vue from 'vue'
import {Dictionary, Module} from 'vuex'
import {RootState, UsersState} from '@/types/store/states'
import {RawUser} from '@/types/entity/RawUser'
import $store from '@/store'
import {API} from '@/constants'

const store: Module<UsersState, RootState> = {
  namespaced: true,
  state: {
    users: {}
  },
  getters: {
    getUser: state => (data: RawUser) => {
      if (state.users[data.id]) {
        state.users[data.id].setData(data)
      } else {
        Vue.set(state.users, data.id, new User(data))
      }
      return state.users[data.id]
    },
    getUsers: (state, getters) => (usersData: RawUser[], returnArray: boolean = true) => {
      const result = returnArray ? [] : {};
      for (const userData of usersData) {
        const user = getters.getUser(userData);
        if (returnArray) {
          (result as User[]).push(user);
        } else {
          (result as { [userId: string]: User })[user.getId()] = user;
        }
      }
      return result;
    }
  },
  mutations: {
  },
  actions: {
    /**
     * Load user
     * @param {*} context
     * @returns {Promise<User|User[]>}
     */
    async loadUser (context, id) {
      const response = await context.dispatch('apiRequest', {
        method: API.admin.getUser,
        data: {user_id: id}
      }, {root: true})
      return context.getters.getUser(response.user)
    },
    async createUser (context, data) {
      const response = await context.dispatch('apiRequest', {
        method: API.admin.createUser,
        data
      }, {root: true})
      return response
    },
    async msgrUnbind (context, data) {
      const response = await context.dispatch('apiRequest', {
        url: API.admin.msgrUnbind,
        data
      }, {root: true})
      return response
    },
    async setUpic (context, data: {upic: Blob, userId: string}) {
      const formData = new FormData();
      formData.append('user_id', data.userId);
      formData.append('file', data.upic, 'userpic.jpg')
      const response = await context.dispatch('apiRequest', {
        url: API.files.upic.upload,
        data: formData
      }, {root: true})
    },
    async upicRemove (context, data) {
      const response = await context.dispatch('apiRequest', {
        method: API.admin.upicRemove,
        data
      }, {root: true})
    },
    async removeUser (context, data) {
      const response = await context.dispatch('apiRequest', {
        method: API.admin.removeUser,
        data
      }, {root: true})
    },
    async findUsers (context, query) {
      const response = await context.dispatch('apiRequest', {
        method: API.admin.findUsers,
        data: query
      }, {root: true})
      return {users: context.getters.getUsers(response.users), count: response.count}
    },
    async updateUser (context, data) {
      const response = await context.dispatch('apiRequest', {
        method: API.admin.updateUser,
        data
      }, {root: true})
      return response
    },
    async setStatus (context, data) {
      const response = await context.dispatch('apiRequest', {
        method: API.admin.setStatus,
        data
      }, {root: true})
      return response
    },
    async setPassword (context, data) {
      const response = await context.dispatch('apiRequest', {
        method: API.admin.setPassword,
        data
      }, {root: true})
      return response
    },
    async setRoles (context, data) {
      const response = await context.dispatch('apiRequest', {
        method: API.admin.setRoles,
        data
      }, {root: true})
      return response
    }
  }
}

export default store
